import {
  GET_SCHEDULED_STREAMS,
  GET_SCHEDULED_STREAMS_SUCCESS,
  GET_SCHEDULED_STREAMS_ERROR,
  GET_SCHEDULED_STREAM,
  GET_SCHEDULED_STREAM_SUCCESS,
  GET_SCHEDULED_STREAM_ERROR,
  CREATE_SCHEDULED_STREAM,
  CREATE_SCHEDULED_STREAM_SUCCESS,
  CREATE_SCHEDULED_STREAM_ERROR,
  UPDATE_SCHEDULED_STREAM,
  UPDATE_SCHEDULED_STREAM_SUCCESS,
  UPDATE_SCHEDULED_STREAM_ERROR,
  DELETE_SCHEDULED_STREAM,
  DELETE_SCHEDULED_STREAM_SUCCESS,
  SIGN_UP_FOR_STREAM,
  SIGN_UP_FOR_STREAM_SUCCESS,
  SIGN_UP_FOR_STREAM_ERROR,
} from './constants';

// Get All Scheduled Streams
export function getScheduledStreams(params) {
  return {
    type: GET_SCHEDULED_STREAMS,
    params,
  };
}

export function getScheduledStreamsSuccess(payload) {
  return {
    type: GET_SCHEDULED_STREAMS_SUCCESS,
    payload,
  };
}

export function getScheduledStreamsError(error) {
  return {
    type: GET_SCHEDULED_STREAMS_ERROR,
    error,
  };
}

// Get Single Scheduled Stream
export function getScheduledStream(id) {
  return {
    type: GET_SCHEDULED_STREAM,
    id,
  };
}

export function getScheduledStreamSuccess(payload) {
  return {
    type: GET_SCHEDULED_STREAM_SUCCESS,
    payload,
  };
}

export function getScheduledStreamFailure(error) {
  return {
    type: GET_SCHEDULED_STREAM_ERROR,
    error,
  };
}

// Create Stream
export function createScheduledStream(data, callback) {
  return {
    type: CREATE_SCHEDULED_STREAM,
    data,
    callback,
  };
}

export function createScheduledStreamSuccess(payload) {
  return {
    type: CREATE_SCHEDULED_STREAM_SUCCESS,
    payload,
  };
}

export function createScheduledStreamFailure(error) {
  return {
    type: CREATE_SCHEDULED_STREAM_ERROR,
    error,
  };
}

// Update Stream
export function updateScheduledStream(id, callback) {
  return {
    type: UPDATE_SCHEDULED_STREAM,
    id,
    callback,
  };
}

export function updateScheduledStreamSuccess(payload) {
  return {
    type: UPDATE_SCHEDULED_STREAM_SUCCESS,
    payload,
  };
}

export function updateScheduledStreamFailure(error) {
  return {
    type: UPDATE_SCHEDULED_STREAM_ERROR,
    error,
  };
}

export function signUpForStream(streamId, callback) {
  return {
    type: SIGN_UP_FOR_STREAM,
    streamId,
    callback,
  };
}

export function signUpForStreamSuccess(payload) {
  return {
    type: SIGN_UP_FOR_STREAM_SUCCESS,
    payload,
  };
}

export function signUpForStreamError(error) {
  return {
    type: SIGN_UP_FOR_STREAM_ERROR,
    error,
  };
}

// Delete Stream
export function deleteScheduledStream(id, callback) {
  return {
    type: DELETE_SCHEDULED_STREAM,
    id,
    callback,
  };
}

export function deleteScheduledStreamSuccess(id) {
  return {
    type: DELETE_SCHEDULED_STREAM_SUCCESS,
    id,
  };
}
